import { SVG_MUI } from "@ryde/assets";
import { LiveMapRideFilterEnum } from "@ryde/shared";

export const RIDE_FILTER_ICONS = {
  [LiveMapRideFilterEnum.all]: SVG_MUI.LiveMapRideFilterAllSVG,
  [LiveMapRideFilterEnum.hideNotTracked]:
    SVG_MUI.LiveMapRideFilterHideNotTrackedSVG,
  [LiveMapRideFilterEnum.hideFuturePastNotTracked]:
    SVG_MUI.LiveMapRideFilterHideFuturePastNotTrackedSVG,
} as const;
